import { Button } from '@heroui/react';
import { FC, ReactNode } from 'react';

import {
  PageTitleActionBar, PageTitleRight, PageTitleWrapper, Title,
} from './PageTitle.styled';

interface PageTitleProps {
    actions?: ReactNode;
    title?: string;
    buttonText?: string;
    buttonOnClick?: () => void;
}
export const PageTitle:FC<PageTitleProps> = (props) => {
  const { actions, title, buttonText, buttonOnClick } = props;
  return (
    <PageTitleWrapper>
      <Title>{title}</Title>
      {(actions || buttonOnClick) && (
        <PageTitleRight>
          {actions && (
            <PageTitleActionBar>{actions}</PageTitleActionBar>
          )}
          {buttonOnClick && (
            <Button
              size="sm"
              onPress={buttonOnClick}
              type="submit"
              radius="full"
              className="bg-black text-white"
            >
              {buttonText}
            </Button>
          )}
        </PageTitleRight>
      )}
    </PageTitleWrapper>
  );
};
